export default import.meta.ROLLUP_FILE_URL_yMp6UPE1vHfoXsELJgKDkw